import {
  BANK_MATCH_STATE_LABELS_RU,
  type BankLineKind,
  type BankLineStatus,
  type BankMatchState,
} from '@crm/shared'
import { Badge } from '../../shared/ui/Badge'

/** Банковские суммы — с копейками: строка выписки должна совпадать с банком до копейки. */
export function formatBankMoney(value: number | null | undefined): string {
  if (value == null) return '—'
  return (
    value.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₽'
  )
}

export function formatBankDate(iso: string | null | undefined): string {
  return iso ? new Date(iso).toLocaleDateString('ru-RU') : ''
}

export function formatBankPeriod(from: string | null, to: string | null): string {
  const a = formatBankDate(from)
  const b = formatBankDate(to)
  if (!a && !b) return '—'
  return a === b || !b ? a : `${a} – ${b}`
}

const KIND_COLORS: Record<BankLineKind, 'green' | 'gray' | 'blue' | 'orange'> = {
  INCOMING: 'green',
  OUTGOING: 'gray',
  DEPOSIT: 'blue',
  REFUND: 'orange',
}

export function BankKindBadge({ kind, label }: { kind: BankLineKind; label: string }) {
  return <Badge color={KIND_COLORS[kind]}>{label}</Badge>
}

export const BANK_STATEMENTS_KEY = ['bank-statements'] as const
export const BANK_ACCOUNTS_KEY = ['bank-accounts'] as const
export const bankStatementKey = (id: string) => ['bank-statement', id] as const
export const BANK_OPEN_LINES_KEY = ['bank-open-lines'] as const
export const BANK_SETTINGS_KEY = ['bank-settings'] as const

const MATCH_COLORS: Record<BankMatchState, 'green' | 'yellow' | 'orange' | 'red'> = {
  AUTO: 'green',
  CONFIRM: 'yellow',
  CHOOSE: 'orange',
  NO_CLIENT: 'red',
}

/** Что программа решила про открытое поступление. */
export function BankMatchBadge({ state }: { state: BankMatchState }) {
  return <Badge color={MATCH_COLORS[state]}>{BANK_MATCH_STATE_LABELS_RU[state]}</Badge>
}

const STATUS_COLORS: Record<BankLineStatus, 'blue' | 'yellow' | 'green' | 'gray'> = {
  PENDING: 'blue',
  PARTIAL: 'yellow',
  ALLOCATED: 'green',
  SKIPPED: 'gray',
}

export function BankStatusBadge({ status, label }: { status: BankLineStatus; label: string }) {
  return <Badge color={STATUS_COLORS[status]}>{label}</Badge>
}
